import React from 'react'
import lazyLoad from '@utils/lazyLoad'

const managementCenterRoutes = [
  {
    path: '/setting/systemSetting/openAPI',
    exact: true,
    component: lazyLoad(() => import('@views/Setting/SystemSetting/OpenAPI')),
    meta: {
      title: 'OpenAPI',
      layoutMode: 'empty'
    }
  },
  {
    path: '/setting/systemSetting/openAPI/detail',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Setting/SystemSetting/OpenAPI/Details')
    ),
    meta: {
      title: 'OpenAPI详情',
      layoutMode: 'empty'
    }
  },
  {
    path: '/setting/systemSetting/persons',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Setting/SystemSetting/Persons')
    ),
    meta: {
      layoutMode: 'empty'
    }
  },
  {
    path: '/setting/systemSetting/persons/new',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Setting/SystemSetting/Persons/Employee')
    ),
    meta: {
      title: '新建员工'
    }
  },
  {
    path: '/setting/systemSetting/persons/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Setting/SystemSetting/Persons/Employee')
    ),
    meta: {
      title: '编辑员工'
    }
  },
  {
    path: '/setting/systemSetting/role',
    exact: true,
    component: lazyLoad(() => import('@views/Setting/SystemSetting/Responsibility'))
  },
]
export default managementCenterRoutes
